/**
 * Shared green-nature surfaces for page help / guide tooltips.
 * Calm moss tint — distinct from semantic warn/danger and from flat chrome.
 */

/** Collapsible page-help banner (`PageHelpBanner`, `PageHelp`). */
export const PAGE_HELP_BANNER_SHELL =
  'border-ok/35 bg-ok-muted/25 open:bg-ok-muted/35'

export const PAGE_HELP_BANNER_SUMMARY_HOVER =
  'hover:bg-ok-muted/40 hover:text-fg'

export const PAGE_HELP_BANNER_INNER_BORDER = 'border-ok/25'

/** Inner section cards inside an expanded help banner. */
export const PAGE_HELP_SECTION_SHELL =
  'rounded-sm border border-ok/20 bg-ok-muted/15 px-2.5 py-2'

/** Hover tooltip popover (`Tooltip` in ui/misc). */
export const TOOLTIP_POPOVER_SHELL =
  'border-edge-subtle bg-surface-raised text-fg shadow-lg backdrop-blur-sm'

/** Field-level config help popover (`ConfigHelp`). */
export const CONFIG_HELP_POPOVER_SHELL =
  'border-edge-subtle bg-surface-raised shadow-overlay backdrop-blur-sm'
